module.exports = __webpack_public_path__ + "static/img/m_banner1.47e52c2b.png";